/**
 * Deep-clones a value via JSON serialization.
 *
 * This is the single, intentional home for the `JSON.parse(JSON.stringify())`
 * pattern. It deliberately strips non-serializable content (functions,
 * `undefined`, symbols, class prototypes), serializes Dates to strings, and
 * detaches the result from Vue reactivity.
 *
 * `structuredClone` is intentionally NOT used here: it throws `DataCloneError`
 * on the non-cloneable values (functions, reactive proxies) that these call
 * sites routinely pass. The return type is `any` to mirror the inline pattern
 * it replaces and preserve existing call-site typing.
 *
 * @param value - The value to deep-clone.
 * @returns A JSON-safe deep copy of `value`.
 */
export default function deepClone(value: any): any {
  // eslint-disable-next-line unicorn/prefer-structured-clone -- intentional JSON sanitize+clone; structuredClone throws on the non-cloneable inputs these call sites pass
  return JSON.parse(JSON.stringify(value));
}
